import type { SVGProps } from "react";
const SenecPictogramEmployees = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 6C11.2386 6 9 8.23858 9 11C9 13.7614 11.2386 16 14 16C16.7614 16 19 13.7614 19 11C19 8.23858 16.7614 6 14 6ZM11 11C11 9.34315 12.3431 8 14 8C15.6569 8 17 9.34315 17 11C17 12.6569 15.6569 14 14 14C12.3431 14 11 12.6569 11 11Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.0945 13.7492C29.2491 14.7725 28 16.7404 28 19C28 22.3137 30.6863 25 34 25C37.3137 25 40 22.3137 40 19C40 16.7404 38.7509 14.7725 36.9055 13.7492C37.5839 13.0324 38 12.0648 38 11C38 8.79086 36.2091 7 34 7C31.7909 7 30 8.79086 30 11C30 12.0648 30.4161 13.0324 31.0945 13.7492ZM34 15C31.7909 15 30 16.7909 30 19C30 21.2091 31.7909 23 34 23C36.2091 23 38 21.2091 38 19C38 16.7909 36.2091 15 34 15ZM34 13C35.1046 13 36 12.1046 36 11C36 9.89543 35.1046 9 34 9C32.8954 9 32 9.89543 32 11C32 12.1046 32.8954 13 34 13Z"
            fill="currentColor"
        />
        <path
            d="M14 18C9.58172 18 6 21.5817 6 26H8C8 22.6863 10.6863 20 14 20C17.3137 20 20 22.6863 20 26C20 26.5523 20.4477 27 21 27C21.5523 27 22 26.5523 22 26C22 21.5817 18.4183 18 14 18Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 29V30H22V42H6V39C6 38.4477 6.44772 38 7 38C7.55228 38 8 38.4477 8 39V40H20V32H8V34C8 34.5523 7.55228 35 7 35C6.44772 35 6 34.5523 6 34V30H10V29C10 27.3431 11.3431 26 13 26H15C16.6569 26 18 27.3431 18 29ZM12 29C12 28.4477 12.4477 28 13 28H15C15.5523 28 16 28.4477 16 29V30H12V29Z"
            fill="currentColor"
        />
        <path
            d="M34 27C29.5817 27 26 30.5817 26 35V42H28V35C28 31.6863 30.6863 29 34 29C37.3137 29 40 31.6863 40 35V42H42V35C42 30.5817 38.4183 27 34 27Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramEmployees;
